<template>
    <content-dashboard :hide="true">
        <v-row>
            <v-col cols="12" md="3" sm="4" v-for="(url, key) in urls">
                <v-card class="mx-auto" min-width="344" outlined>
                    <v-list-item three-line>
                        <v-list-item-content class="text-center">
                            <v-list-item-title class="headline mt-2 mb-3">
                                <v-icon color="primary" x-large>{{ url.icon }}</v-icon>
                            </v-list-item-title>
                            <div class="overline mb-3">{{ url.name }}</div>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-actions>
                        <v-btn outlined rounded text v-bind:href="url.action">Gerenciar Dados</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </content-dashboard>
</template>

<script>
export default {
    name: "Tabelas de apoio",
    
    components: {},
    
    data() {
        return {
            urls: [
                {
                    icon: 'fa-file',
                    name: 'Observações',
                    action: 'tabelas-de-apoio/observacoes',
                },
            ],
        }
    },

    created() {},

    methods: {},
}
</script>
